import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async createUser({ commit }, data) {
      try {
        return await api.post(`/admin/users`, data)
      } catch (error) {
        throw error
      }
    },

    async getUsers({ commit }, data) {
      try {
        const response = await api.get(`/admin/users`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async deleteUser({ commit }, id) {
      try {
        return await api.delete(`/admin/users/${id}`)
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
